import clsx from 'clsx';
import React from 'react';

import { InboxPageContext } from 'src/context/inboxPageContext';
import { useContextBar } from 'src/hooks/useContextBar';
import { LoadingWrapper } from 'src/legacy/components/Loading';
import { useGetInboxNotificationsQuery } from 'src/services/api/inboxApi';

import { InboxContent } from './InboxContent';
import { InboxSidebar, InboxSidebarItemData } from './InboxSidebar';

export const InboxPage = () => {
  const { open: contextBarOpen } = useContextBar();

  const { isLoading: areAllNotificationsLoading } =
    useGetInboxNotificationsQuery();

  const [selectedNotification, setSelectedNotification] =
    React.useState<InboxSidebarItemData | null>(null);

  const inboxPageContextValue = React.useMemo(
    () => ({
      selectedNotification,
      setSelectedNotification,
    }),
    [selectedNotification, setSelectedNotification],
  );

  return (
    <InboxPageContext.Provider value={inboxPageContextValue}>
      <LoadingWrapper
        hideContentWhileLoading
        isLoading={areAllNotificationsLoading}
      >
        <div
          className={clsx('h-full flex', !contextBarOpen && 'overflow-hidden')}
        >
          <InboxSidebar />
          <InboxContent />
        </div>
      </LoadingWrapper>
    </InboxPageContext.Provider>
  );
};
